export const topOffset = ({ theme: { dimensions } }) => ({
    marginTop: dimensions.navbarHeight,
    overflow: 'hidden',
});
